export const EXPANDED_COOKIE = 'rt-promo-expanded'
export const DISMISS_COOKIE = 'rt-promo-dismissed'
export const DISMISS_PREFERENCE = 'rt-promo.dismissed.dateTime'
export const COLLAPSED_PREFERENCE = 'rt-promo.collapsed.dateTime'
export const DISMISS_SESSION_FLAG = 'rt-promo-dismiss-pending-sync'
export const COLLAPSED_SESSION_FLAG = 'rt-promo-collapsed-pending-sync'
export const BANNER_PORTAL_ID = 'rootstech-promo-banner-root'
export const CROSS_TAB_CHANNEL = 'rt-promo'
export const COOKIE_EXPIRATION_DAYS = 30
export const PROMO_FLAG = 'rootstech_fs_promo'
export const PROMO_DATE_FLAG = 'rootstech_fs_promo_date'
